// extracted by mini-css-extract-plugin
export default {"artist":"ModifyForm_artist__FQOO7"};